import React, { useState, useRef, useEffect } from 'react';
import { Button } from '../ui/Kit';
import Spinner from '../ui/Spinner';

export default function SMSInputBar({ onSend, disabled, placeholder }) {
  const [body, setBody] = useState('');
  const [sending, setSending] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 120)}px`;
    }
  }, [body]);

  const handleSend = async () => {
    const trimmed = body.trim();
    if (!trimmed || sending) return;
    setSending(true);
    try {
      await onSend(trimmed);
      setBody('');
    } finally {
      setSending(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const charCount = body.length;

  return (
    <div className="border-t border-gray-200 bg-white px-4 py-3 shrink-0">
      <div className="flex items-end gap-2">
        <div className="flex-1 relative">
          <textarea
            ref={textareaRef}
            value={body}
            onChange={(e) => setBody(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder || 'Type a message…'}
            disabled={disabled || sending}
            rows={1}
            className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-primary focus:border-transparent outline-none resize-none disabled:opacity-50"
          />
          <span className={`absolute right-2 bottom-1.5 text-[10px] ${charCount > 160 ? 'text-red-500 font-semibold' : 'text-gray-400'}`}>
            {charCount}/160
          </span>
        </div>
        <Button
          size="sm"
          onClick={handleSend}
          disabled={!body.trim() || disabled || sending}
          className="shrink-0"
        >
          {sending ? (
            <>
              <Spinner className="mr-1.5 h-3.5 w-3.5" />
              Sending…
            </>
          ) : (
            'Send'
          )}
        </Button>
      </div>
    </div>
  );
}
